import { AppBar, Toolbar, Box, Typography, Avatar, IconButton, Tooltip } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/reducers/index";
import { sessionEnd } from "../redux/actions";
import logo from "../img/logo/Kairos-removebg-preview.webp";

// On ajoute la prop showMenuButton pour cacher le menu burger sur la Home
const Navbar = ({ onMenuClick, showMenuButton = true, blueLogoFilter = false, accentColor = "#3b82f6" }: { onMenuClick?: () => void, showMenuButton?: boolean, blueLogoFilter?: boolean, accentColor?: string }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const username = useSelector((state: RootState) => state.user.username);

    return (
        <AppBar 
            position="fixed" 
            sx={{ 
                zIndex: (theme) => theme.zIndex.drawer + 1,
                bgcolor: "white", 
                color: "#1e293b",
                boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                borderBottom: "1px solid #e2e8f0"
            }}
        >
            <Toolbar sx={{ justifyContent: "space-between", minHeight: 70 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    {showMenuButton && (
                        <IconButton onClick={onMenuClick} sx={{ color: "#0f172a" }}>
                            <MenuIcon />
                        </IconButton>
                    )}
                    <Box 
                        component="img" 
                        src={logo} 
                        sx={{ height: 38, cursor: "pointer", "&:hover": { transform: "scale(1.05)" }, transition: "0.2s", ...(blueLogoFilter && { filter: "hue-rotate(200deg) saturate(1.5) brightness(0.95)" }) }} 
                        onClick={() => navigate("/")} 
                    />
                    <Typography 
                        variant="h6" 
                        sx={{ fontWeight: 800, color: "#0f172a", letterSpacing: -1, cursor: "pointer", "&:hover": { color: "#0f172a" }, transition: "0.2s" }} 
                        onClick={() => navigate("/")}
                    >
                        Kairos
                    </Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Box sx={{ textAlign: 'right', display: {xs: 'none', sm: 'block'} }}>
                        <Typography variant="body2" sx={{ fontWeight: 700, color: "#1e293b" }}>{username}</Typography>
                        <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>Connecté</Typography>
                    </Box>
                    <Avatar sx={{ width: 38, height: 38, bgcolor: "#3b82f6", fontSize: 14, fontWeight: 700, border: "2px solid #eff6ff" }}>
                        {username?.charAt(0).toUpperCase()}
                    </Avatar>
                    <Tooltip title="Déconnexion">
                        <IconButton onClick={() => dispatch(sessionEnd())} sx={{ color: "#94a3b8", "&:hover": { color: "#ef4444", bgcolor: "#fee2e2" } }}>
                            <LogoutIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default Navbar;